<h1 class="mb-0">My Production</h1>
<small class="text-muted">{{ weekLabel }}</small>

<div class="row">
	<div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">WEEK TOTAL</p>
				<h4>{{ leads.length }}</h4>
			</div>
		</div>
	</div>
	<!-- <div class="col-md-3">
		<div class="card card-animate card-blue">
			<div class="card-body">
				<p class="text-muted mb-0">DIALS TODAY</p>
				<h4>{{ dialsToday }}</h4>
			</div>
		</div>
	</div> -->
	<!-- <div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">APPOINTMENTS</p>
				<h4> {{ appointmentsThisWeek }}</h4>
			</div>
		</div>
	</div> -->
	<!-- <div class="col-md-3">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">HOURS MON</p>
				<h4>0</h4>
			</div>
		</div>
	</div> -->

	<div class="card mt-4">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h5 class="mb-0">
				This Week's Leads <span class="lead-total">({{ leads.length }})</span>
			</h5>

			<div class="d-flex align-items-center gap-2 position-relative">
				<button type="button" class="btn btn-sm btn-outline-secondary" (click)="goToPreviousWeek()" aria-label="Previous week">&lsaquo;</button>

				<button #weekPickerToggle type="button" class="btn btn-sm btn-outline-secondary week-picker-toggle" (click)="toggleWeekPicker()">
					{{ weekLabel }}
				</button>

				<button type="button" class="btn btn-sm btn-outline-secondary" (click)="goToNextWeek()" [disabled]="isCurrentWeek" aria-label="Next week">&rsaquo;</button>

				<div class="week-picker-backdrop" *ngIf="showWeekPicker" (click)="closeWeekPicker()"></div>

				<div class="week-picker-dropdown card shadow" *ngIf="showWeekPicker" [style.top.px]="weekPickerPosition.top" [style.left.px]="weekPickerPosition.left">
					<div class="card-body p-2">
						<div class="d-flex justify-content-between align-items-center mb-2">
							<button type="button" class="btn btn-sm btn-link p-0" (click)="shiftCalendarMonth(-1)">&lsaquo;</button>
							<strong class="small">{{ calendarMonthLabel }}</strong>
							<button type="button" class="btn btn-sm btn-link p-0" (click)="shiftCalendarMonth(1)">&rsaquo;</button>
						</div>

						<table class="table table-sm mb-0 week-picker-table">
							<thead>
								<tr>
									<th *ngFor="let d of weekdayLabels">{{ d }}</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let week of calendarWeeks" class="week-row" [class.selected-week]="isSelectedWeek(week[0].date)" [class.disabled-week]="isFutureWeek(week[0].date)" (click)="selectWeekFromCalendar(week[0].date)">
									<td *ngFor="let day of week" [class.text-muted]="day.otherMonth">
										{{ day.date.getDate() }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		<div class="card-body p-0">
			<div class="table-responsive">
				<table class="table table-striped mb-0" *ngIf="leads.length > 0; else noData">
					<thead class="table-light">
						<tr>
							<th>Lead ID</th>
							<th>Date</th>
							<th>Campaign</th>
							<th>Prospect</th>
							<th>Billed</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let lead of leads">
							<td>{{ lead.id }}</td>
							<td>{{ lead.date | date: "mediumDate" }}</td>
							<td>{{ lead.campaign }}</td>
							<td>{{ lead.prospect }}</td>
							<td>
								<span class="badge" [ngClass]="{ 'badge-green': lead.billed === 'Billed', 'badge-red': lead.billed === 'Not Billed' }">{{ lead.billed }}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<ng-template #noData>
			<p class="p-3">Leads not available.</p>
		</ng-template>
	</div>
</div>
